import React, { useMemo } from 'react';
import styles from './SkillPaths.module.scss';
import { Grid } from '@material-ui/core';
import { format, parseISO } from 'date-fns';
import { useLearningPathsStore } from '../LearningPaths/LearningPaths.store';
import EmptyStateCard from './EmptyStateCard';
import { CustomButton } from 'shared_ui_components';

const ResumeChart = ({ title = '', skillPath = {}, due = new Date() }) => {
  const { setSelectedRepLearningPathID } = useLearningPathsStore();
  const completedStyles = useMemo(
    () => ({
      left: 0,
      width: `${Math.round(skillPath?.percent_completed)}%`,
    }),
    [skillPath]
  );
  if (Object.keys(skillPath).length <= 0)
    return <EmptyStateCard emptyStateText="No Skill Path in Progress" />;

  return (
    <div className={styles.progressChart}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLine1}>
          <span className={styles.headerPeriod}>Continue Skill Path</span>
          {due && (
            <span className={styles.headerPeriod}>Due {format(parseISO(due), 'MMM do, yyyy')}</span>
          )}
        </div>
        <span className={styles.headerTitle}>{title}</span>
      </div>
      <div className={styles.bodyResume}>
        <Grid item xs={12} md={12} className={styles.bodyResumeContent}>
          <span className={styles.bodyResumeDescription}>
            {skillPath?.learning_path?.description}
          </span>
          <div className={styles.resumeProgress}>
            <span>
              <strong>
                {skillPath?.completed_modules} /{' '}
                {skillPath?.completed_modules + skillPath?.pending_modules}
              </strong>{' '}
              Skill Sets
            </span>
            {/* <ProgressBar
              max={100}
              value={skillPath?.percent_completed}
              // className={`${styles.salesProgressBar} ${
              //   goal?.goal_data?.progress < 50 ? styles.danger : ''
              // }`}
            /> */}
            <div className={styles.progressBar}>
              <div className={styles.completed} style={completedStyles} />
            </div>
            <div>{Math.round(skillPath?.percent_completed)}%</div>
          </div>
          <div>
            <CustomButton
              onClick={() => {
                setSelectedRepLearningPathID(skillPath?.learning_path?.uuid);
              }}
            >
              Continue
            </CustomButton>
          </div>
        </Grid>
      </div>
    </div>
  );
};

export default ResumeChart;
